'use strict';

var _defineProperty = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/defineProperty.js");
var _createClass = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _regeneratorRuntime = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _asyncGeneratorDelegate = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate.js");
var _awaitAsyncGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/awaitAsyncGenerator.js");
var _wrapAsyncGenerator = require("/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/wrapAsyncGenerator.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
require("core-js/modules/esnext.global-this.js");
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
var AbortController = globalThis.AbortController || require('abort-controller').AbortController;
var _require = require('../../ours/errors'),
  _require$codes = _require.codes,
  ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_OUT_OF_RANGE = _require$codes.ERR_OUT_OF_RANGE,
  AbortError = _require.AbortError;
var _require2 = require('../validators'),
  validateAbortSignal = _require2.validateAbortSignal,
  validateInteger = _require2.validateInteger,
  validateObject = _require2.validateObject;
var kWeakHandler = require('../../ours/primordials').Symbol('kWeak');
var kResistStopPropagation = require('../../ours/primordials').Symbol('kResistStopPropagation');
var _require3 = require('./end-of-stream'),
  finished = _require3.finished;
var staticCompose = require('./compose');
var _require4 = require('./add-abort-signal'),
  addAbortSignalNoValidate = _require4.addAbortSignalNoValidate;
var _require5 = require('./utils'),
  isWritable = _require5.isWritable,
  isNodeStream = _require5.isNodeStream;
var _require6 = require('../../ours/util'),
  deprecate = _require6.deprecate;
var _require7 = require('../../ours/primordials'),
  ArrayPrototypePush = _require7.ArrayPrototypePush,
  _Boolean = _require7.Boolean,
  MathFloor = _require7.MathFloor,
  Number = _require7.Number,
  NumberIsNaN = _require7.NumberIsNaN,
  _Promise = _require7.Promise,
  PromiseReject = _require7.PromiseReject,
  PromiseResolve = _require7.PromiseResolve,
  PromisePrototypeThen = _require7.PromisePrototypeThen,
  _Symbol = _require7.Symbol;
var kEmpty = _Symbol('kEmpty');
var kEof = _Symbol('kEof');
function compose(stream, options) {
  if (options != null) {
    validateObject(options, 'options');
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal');
  }
  if (isNodeStream(stream) && !isWritable(stream)) {
    throw new ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable');
  }
  var composedStream = staticCompose(this, stream);
  if (options !== null && options !== undefined && options.signal) {
    // Not validating as we already validated before
    addAbortSignalNoValidate(options.signal, composedStream);
  }
  return composedStream;
}
function map(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn);
  }
  if (options != null) {
    validateObject(options, 'options');
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal');
  }
  var concurrency = 1;
  if ((options === null || options === undefined ? undefined : options.concurrency) != null) {
    concurrency = MathFloor(options.concurrency);
  }
  var highWaterMark = concurrency - 1;
  if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) {
    highWaterMark = MathFloor(options.highWaterMark);
  }
  validateInteger(concurrency, 'options.concurrency', 1);
  validateInteger(highWaterMark, 'options.highWaterMark', 0);
  highWaterMark += concurrency;
  return /*#__PURE__*/function () {
    var _map = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var signal, stream, queue, signalOpt, next, resume, done, cnt, onCatch, afterItemProcessed, maybeResume, pump, _pump, val;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _pump = function _pump3() {
              _pump = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _val, _val2;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _iteratorAbruptCompletion = false;
                      _didIteratorError = false;
                      _context.prev = 3;
                      _iterator = _asyncIterator(stream);
                    case 5:
                      _context.next = 7;
                      return _iterator.next();
                    case 7:
                      if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                        _context.next = 33;
                        break;
                      }
                      _val = _step.value;
                      if (!done) {
                        _context.next = 11;
                        break;
                      }
                      return _context.abrupt("return");
                    case 11:
                      if (!signal.aborted) {
                        _context.next = 13;
                        break;
                      }
                      throw new AbortError();
                    case 13:
                      _context.prev = 13;
                      _val = fn(_val, signalOpt);
                      if (!(_val === kEmpty)) {
                        _context.next = 17;
                        break;
                      }
                      return _context.abrupt("continue", 30);
                    case 17:
                      _val = PromiseResolve(_val);
                      _context.next = 23;
                      break;
                    case 20:
                      _context.prev = 20;
                      _context.t0 = _context["catch"](13);
                      _val = PromiseReject(_context.t0);
                    case 23:
                      cnt += 1;
                      PromisePrototypeThen(_val, afterItemProcessed, onCatch);
                      queue.push(_val);
                      if (next) {
                        next();
                        next = null;
                      }
                      if (!(!done && (queue.length >= highWaterMark || cnt >= concurrency))) {
                        _context.next = 30;
                        break;
                      }
                      _context.next = 30;
                      return new _Promise(function (resolve) {
                        resume = resolve;
                      });
                    case 30:
                      _iteratorAbruptCompletion = false;
                      _context.next = 5;
                      break;
                    case 33:
                      _context.next = 39;
                      break;
                    case 35:
                      _context.prev = 35;
                      _context.t1 = _context["catch"](3);
                      _didIteratorError = true;
                      _iteratorError = _context.t1;
                    case 39:
                      _context.prev = 39;
                      _context.prev = 40;
                      if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                        _context.next = 44;
                        break;
                      }
                      _context.next = 44;
                      return _iterator.return();
                    case 44:
                      _context.prev = 44;
                      if (!_didIteratorError) {
                        _context.next = 47;
                        break;
                      }
                      throw _iteratorError;
                    case 47:
                      return _context.finish(44);
                    case 48:
                      return _context.finish(39);
                    case 49:
                      queue.push(kEof);
                      _context.next = 57;
                      break;
                    case 52:
                      _context.prev = 52;
                      _context.t2 = _context["catch"](0);
                      _val2 = PromiseReject(_context.t2);
                      PromisePrototypeThen(_val2, afterItemProcessed, onCatch);
                      queue.push(_val2);
                    case 57:
                      _context.prev = 57;
                      done = true;
                      if (next) {
                        next();
                        next = null;
                      }
                      return _context.finish(57);
                    case 61:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 52, 57, 61], [3, 35, 39, 49], [13, 20], [40,, 44, 48]]);
              }));
              return _pump.apply(this, arguments);
            };
            pump = function _pump2() {
              return _pump.apply(this, arguments);
            };
            maybeResume = function _maybeResume() {
              if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
              }
            };
            afterItemProcessed = function _afterItemProcessed() {
              cnt -= 1;
              maybeResume();
            };
            onCatch = function _onCatch() {
              done = true;
              afterItemProcessed();
            };
            signal = require('../../ours/util').AbortSignalAny([options === null || options === undefined ? undefined : options.signal].filter(_Boolean));
            stream = this;
            queue = [];
            signalOpt = {
              signal: signal
            };
            done = false;
            cnt = 0;
            pump();
            _context2.prev = 12;
          case 13:
            if (!true) {
              _context2.next = 33;
              break;
            }
          case 14:
            if (!(queue.length > 0)) {
              _context2.next = 29;
              break;
            }
            _context2.next = 17;
            return _awaitAsyncGenerator(queue[0]);
          case 17:
            val = _context2.sent;
            if (!(val === kEof)) {
              _context2.next = 20;
              break;
            }
            return _context2.abrupt("return");
          case 20:
            if (!signal.aborted) {
              _context2.next = 22;
              break;
            }
            throw new AbortError();
          case 22:
            if (!(val !== kEmpty)) {
              _context2.next = 25;
              break;
            }
            _context2.next = 25;
            return val;
          case 25:
            queue.shift();
            maybeResume();
            _context2.next = 14;
            break;
          case 29:
            _context2.next = 31;
            return _awaitAsyncGenerator(new _Promise(function (resolve) {
              next = resolve;
            }));
          case 31:
            _context2.next = 13;
            break;
          case 33:
            _context2.prev = 33;
            done = true;
            if (resume) {
              resume();
              resume = null;
            }
            return _context2.finish(33);
          case 37:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[12,, 33, 37]]);
    }));
    function map() {
      return _map.apply(this, arguments);
    }
    return map;
  }().call(this);
}
function asIndexedPairs() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  if (options != null) {
    validateObject(options, 'options');
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal');
  }
  return /*#__PURE__*/function () {
    var _asIndexedPairs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var index, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, val, _options$signal;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            index = 0;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context3.prev = 3;
            _iterator2 = _asyncIterator(this);
          case 5:
            _context3.next = 7;
            return _awaitAsyncGenerator(_iterator2.next());
          case 7:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
              _context3.next = 16;
              break;
            }
            val = _step2.value;
            if (!(options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted)) {
              _context3.next = 11;
              break;
            }
            throw new AbortError({
              cause: options.signal.reason
            });
          case 11:
            _context3.next = 13;
            return [index++, val];
          case 13:
            _iteratorAbruptCompletion2 = false;
            _context3.next = 5;
            break;
          case 16:
            _context3.next = 22;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](3);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t0;
          case 22:
            _context3.prev = 22;
            _context3.prev = 23;
            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context3.next = 27;
              break;
            }
            _context3.next = 27;
            return _awaitAsyncGenerator(_iterator2.return());
          case 27:
            _context3.prev = 27;
            if (!_didIteratorError2) {
              _context3.next = 30;
              break;
            }
            throw _iteratorError2;
          case 30:
            return _context3.finish(27);
          case 31:
            return _context3.finish(22);
          case 32:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[3, 18, 22, 32], [23,, 27, 31]]);
    }));
    function asIndexedPairs() {
      return _asIndexedPairs.apply(this, arguments);
    }
    return asIndexedPairs;
  }().call(this);
}
function some(_x) {
  return _some.apply(this, arguments);
}
function _some() {
  _some = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(fn) {
    var options,
      _iteratorAbruptCompletion3,
      _didIteratorError3,
      _iteratorError3,
      _iterator3,
      _step3,
      unused,
      _args8 = arguments;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : undefined;
          _iteratorAbruptCompletion3 = false;
          _didIteratorError3 = false;
          _context8.prev = 3;
          _iterator3 = _asyncIterator(filter.call(this, fn, options));
        case 5:
          _context8.next = 7;
          return _iterator3.next();
        case 7:
          if (!(_iteratorAbruptCompletion3 = !(_step3 = _context8.sent).done)) {
            _context8.next = 13;
            break;
          }
          unused = _step3.value;
          return _context8.abrupt("return", true);
        case 10:
          _iteratorAbruptCompletion3 = false;
          _context8.next = 5;
          break;
        case 13:
          _context8.next = 19;
          break;
        case 15:
          _context8.prev = 15;
          _context8.t0 = _context8["catch"](3);
          _didIteratorError3 = true;
          _iteratorError3 = _context8.t0;
        case 19:
          _context8.prev = 19;
          _context8.prev = 20;
          if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
            _context8.next = 24;
            break;
          }
          _context8.next = 24;
          return _iterator3.return();
        case 24:
          _context8.prev = 24;
          if (!_didIteratorError3) {
            _context8.next = 27;
            break;
          }
          throw _iteratorError3;
        case 27:
          return _context8.finish(24);
        case 28:
          return _context8.finish(19);
        case 29:
          return _context8.abrupt("return", false);
        case 30:
        case "end":
          return _context8.stop();
      }
    }, _callee8, this, [[3, 15, 19, 29], [20,, 24, 28]]);
  }));
  return _some.apply(this, arguments);
}
function every(_x2) {
  return _every.apply(this, arguments);
}
function _every() {
  _every = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(fn) {
    var options,
      _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : undefined;
          if (!(typeof fn !== 'function')) {
            _context10.next = 3;
            break;
          }
          throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn);
        case 3:
          _context10.next = 5;
          return some.call(this, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
            var _args9 = arguments;
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return fn.apply(void 0, _args9);
                case 2:
                  return _context9.abrupt("return", !_context9.sent);
                case 3:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          })), options);
        case 5:
          return _context10.abrupt("return", !_context10.sent);
        case 6:
        case "end":
          return _context10.stop();
      }
    }, _callee10, this);
  }));
  return _every.apply(this, arguments);
}
function find(_x3, _x4) {
  return _find.apply(this, arguments);
}
function _find() {
  _find = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(fn, options) {
    var _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, result;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _iteratorAbruptCompletion4 = false;
          _didIteratorError4 = false;
          _context11.prev = 2;
          _iterator4 = _asyncIterator(filter.call(this, fn, options));
        case 4:
          _context11.next = 6;
          return _iterator4.next();
        case 6:
          if (!(_iteratorAbruptCompletion4 = !(_step4 = _context11.sent).done)) {
            _context11.next = 12;
            break;
          }
          result = _step4.value;
          return _context11.abrupt("return", result);
        case 9:
          _iteratorAbruptCompletion4 = false;
          _context11.next = 4;
          break;
        case 12:
          _context11.next = 18;
          break;
        case 14:
          _context11.prev = 14;
          _context11.t0 = _context11["catch"](2);
          _didIteratorError4 = true;
          _iteratorError4 = _context11.t0;
        case 18:
          _context11.prev = 18;
          _context11.prev = 19;
          if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
            _context11.next = 23;
            break;
          }
          _context11.next = 23;
          return _iterator4.return();
        case 23:
          _context11.prev = 23;
          if (!_didIteratorError4) {
            _context11.next = 26;
            break;
          }
          throw _iteratorError4;
        case 26:
          return _context11.finish(23);
        case 27:
          return _context11.finish(18);
        case 28:
          return _context11.abrupt("return", undefined);
        case 29:
        case "end":
          return _context11.stop();
      }
    }, _callee11, this, [[2, 14, 18, 28], [19,, 23, 27]]);
  }));
  return _find.apply(this, arguments);
}
function forEach(_x5, _x6) {
  return _forEach.apply(this, arguments);
}
function _forEach() {
  _forEach = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(fn, options) {
    var forEachFn, _forEachFn, _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, unused;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _forEachFn = function _forEachFn3() {
            _forEachFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(value, options) {
              return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    _context12.next = 2;
                    return fn(value, options);
                  case 2:
                    return _context12.abrupt("return", kEmpty);
                  case 3:
                  case "end":
                    return _context12.stop();
                }
              }, _callee12);
            }));
            return _forEachFn.apply(this, arguments);
          };
          forEachFn = function _forEachFn2(_x13, _x14) {
            return _forEachFn.apply(this, arguments);
          };
          if (!(typeof fn !== 'function')) {
            _context13.next = 4;
            break;
          }
          throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn);
        case 4:
          // eslint-disable-next-line no-unused-vars
          _iteratorAbruptCompletion5 = false;
          _didIteratorError5 = false;
          _context13.prev = 6;
          _iterator5 = _asyncIterator(map.call(this, forEachFn, options));
        case 8:
          _context13.next = 10;
          return _iterator5.next();
        case 10:
          if (!(_iteratorAbruptCompletion5 = !(_step5 = _context13.sent).done)) {
            _context13.next = 16;
            break;
          }
          unused = _step5.value;
          ;
        case 13:
          _iteratorAbruptCompletion5 = false;
          _context13.next = 8;
          break;
        case 16:
          _context13.next = 22;
          break;
        case 18:
          _context13.prev = 18;
          _context13.t0 = _context13["catch"](6);
          _didIteratorError5 = true;
          _iteratorError5 = _context13.t0;
        case 22:
          _context13.prev = 22;
          _context13.prev = 23;
          if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
            _context13.next = 27;
            break;
          }
          _context13.next = 27;
          return _iterator5.return();
        case 27:
          _context13.prev = 27;
          if (!_didIteratorError5) {
            _context13.next = 30;
            break;
          }
          throw _iteratorError5;
        case 30:
          return _context13.finish(27);
        case 31:
          return _context13.finish(22);
        case 32:
        case "end":
          return _context13.stop();
      }
    }, _callee13, this, [[6, 18, 22, 32], [23,, 27, 31]]);
  }));
  return _forEach.apply(this, arguments);
}
function filter(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn);
  }
  function filterFn(_x7, _x8) {
    return _filterFn.apply(this, arguments);
  }
  function _filterFn() {
    _filterFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value, options) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fn(value, options);
          case 2:
            if (!_context4.sent) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return", value);
          case 4:
            return _context4.abrupt("return", kEmpty);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _filterFn.apply(this, arguments);
  }
  return map.call(this, filterFn, options);
}

// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
var ReduceAwareErrMissingArgs = /*#__PURE__*/function (_ERR_MISSING_ARGS) {
  _inherits(ReduceAwareErrMissingArgs, _ERR_MISSING_ARGS);
  var _super = _createSuper(ReduceAwareErrMissingArgs);
  function ReduceAwareErrMissingArgs() {
    var _this;
    _classCallCheck(this, ReduceAwareErrMissingArgs);
    _this = _super.call(this, 'reduce');
    _this.message = 'Reduce of an empty stream requires an initial value';
    return _this;
  }
  return _createClass(ReduceAwareErrMissingArgs);
}(ERR_MISSING_ARGS);
function reduce(_x9, _x10, _x11) {
  return _reduce.apply(this, arguments);
}
function _reduce() {
  _reduce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(reducer, initialValue, options) {
    var _options$signal2,
      hasInitialValue,
      err,
      ac,
      signal,
      _opts,
      opts,
      gotAnyItemFromStream,
      _iteratorAbruptCompletion6,
      _didIteratorError6,
      _iteratorError6,
      _iterator6,
      _step6,
      value,
      _options$signal3,
      _args14 = arguments;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          if (!(typeof reducer !== 'function')) {
            _context14.next = 2;
            break;
          }
          throw new ERR_INVALID_ARG_TYPE('reducer', ['Function', 'AsyncFunction'], reducer);
        case 2:
          if (options != null) {
            validateObject(options, 'options');
          }
          if ((options === null || options === undefined ? undefined : options.signal) != null) {
            validateAbortSignal(options.signal, 'options.signal');
          }
          hasInitialValue = _args14.length > 1;
          if (!(options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted)) {
            _context14.next = 11;
            break;
          }
          err = new AbortError(undefined, {
            cause: options.signal.reason
          });
          this.once('error', function () {}); // The error is already propagated
          _context14.next = 10;
          return finished(this.destroy(err));
        case 10:
          throw err;
        case 11:
          ac = new AbortController();
          signal = ac.signal;
          if (options !== null && options !== undefined && options.signal) {
            opts = (_opts = {
              once: true
            }, _defineProperty(_opts, kWeakHandler, this), _defineProperty(_opts, kResistStopPropagation, true), _opts);
            options.signal.addEventListener('abort', function () {
              return ac.abort();
            }, opts);
          }
          gotAnyItemFromStream = false;
          _context14.prev = 15;
          _iteratorAbruptCompletion6 = false;
          _didIteratorError6 = false;
          _context14.prev = 18;
          _iterator6 = _asyncIterator(this);
        case 20:
          _context14.next = 22;
          return _iterator6.next();
        case 22:
          if (!(_iteratorAbruptCompletion6 = !(_step6 = _context14.sent).done)) {
            _context14.next = 38;
            break;
          }
          value = _step6.value;
          gotAnyItemFromStream = true;
          if (!(options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted)) {
            _context14.next = 27;
            break;
          }
          throw new AbortError();
        case 27:
          if (hasInitialValue) {
            _context14.next = 32;
            break;
          }
          initialValue = value;
          hasInitialValue = true;
          _context14.next = 35;
          break;
        case 32:
          _context14.next = 34;
          return reducer(initialValue, value, {
            signal: signal
          });
        case 34:
          initialValue = _context14.sent;
        case 35:
          _iteratorAbruptCompletion6 = false;
          _context14.next = 20;
          break;
        case 38:
          _context14.next = 44;
          break;
        case 40:
          _context14.prev = 40;
          _context14.t0 = _context14["catch"](18);
          _didIteratorError6 = true;
          _iteratorError6 = _context14.t0;
        case 44:
          _context14.prev = 44;
          _context14.prev = 45;
          if (!(_iteratorAbruptCompletion6 && _iterator6.return != null)) {
            _context14.next = 49;
            break;
          }
          _context14.next = 49;
          return _iterator6.return();
        case 49:
          _context14.prev = 49;
          if (!_didIteratorError6) {
            _context14.next = 52;
            break;
          }
          throw _iteratorError6;
        case 52:
          return _context14.finish(49);
        case 53:
          return _context14.finish(44);
        case 54:
          if (!(!gotAnyItemFromStream && !hasInitialValue)) {
            _context14.next = 56;
            break;
          }
          throw new ReduceAwareErrMissingArgs();
        case 56:
          _context14.prev = 56;
          ac.abort();
          return _context14.finish(56);
        case 59:
          return _context14.abrupt("return", initialValue);
        case 60:
        case "end":
          return _context14.stop();
      }
    }, _callee14, this, [[15,, 56, 59], [18, 40, 44, 54], [45,, 49, 53]]);
  }));
  return _reduce.apply(this, arguments);
}
function toArray(_x12) {
  return _toArray.apply(this, arguments);
}
function _toArray() {
  _toArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(options) {
    var result, _iteratorAbruptCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, val, _options$signal4;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          if (options != null) {
            validateObject(options, 'options');
          }
          if ((options === null || options === undefined ? undefined : options.signal) != null) {
            validateAbortSignal(options.signal, 'options.signal');
          }
          result = [];
          _iteratorAbruptCompletion7 = false;
          _didIteratorError7 = false;
          _context15.prev = 5;
          _iterator7 = _asyncIterator(this);
        case 7:
          _context15.next = 9;
          return _iterator7.next();
        case 9:
          if (!(_iteratorAbruptCompletion7 = !(_step7 = _context15.sent).done)) {
            _context15.next = 17;
            break;
          }
          val = _step7.value;
          if (!(options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted)) {
            _context15.next = 13;
            break;
          }
          throw new AbortError(undefined, {
            cause: options.signal.reason
          });
        case 13:
          ArrayPrototypePush(result, val);
        case 14:
          _iteratorAbruptCompletion7 = false;
          _context15.next = 7;
          break;
        case 17:
          _context15.next = 23;
          break;
        case 19:
          _context15.prev = 19;
          _context15.t0 = _context15["catch"](5);
          _didIteratorError7 = true;
          _iteratorError7 = _context15.t0;
        case 23:
          _context15.prev = 23;
          _context15.prev = 24;
          if (!(_iteratorAbruptCompletion7 && _iterator7.return != null)) {
            _context15.next = 28;
            break;
          }
          _context15.next = 28;
          return _iterator7.return();
        case 28:
          _context15.prev = 28;
          if (!_didIteratorError7) {
            _context15.next = 31;
            break;
          }
          throw _iteratorError7;
        case 31:
          return _context15.finish(28);
        case 32:
          return _context15.finish(23);
        case 33:
          return _context15.abrupt("return", result);
        case 34:
        case "end":
          return _context15.stop();
      }
    }, _callee15, this, [[5, 19, 23, 33], [24,, 28, 32]]);
  }));
  return _toArray.apply(this, arguments);
}
function flatMap(fn, options) {
  var values = map.call(this, fn, options);
  return /*#__PURE__*/function () {
    var _flatMap = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _iteratorAbruptCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, val;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _iteratorAbruptCompletion8 = false;
            _didIteratorError8 = false;
            _context5.prev = 2;
            _iterator8 = _asyncIterator(values);
          case 4:
            _context5.next = 6;
            return _awaitAsyncGenerator(_iterator8.next());
          case 6:
            if (!(_iteratorAbruptCompletion8 = !(_step8 = _context5.sent).done)) {
              _context5.next = 12;
              break;
            }
            val = _step8.value;
            return _context5.delegateYield(_asyncGeneratorDelegate(_asyncIterator(val), _awaitAsyncGenerator), "t0", 9);
          case 9:
            _iteratorAbruptCompletion8 = false;
            _context5.next = 4;
            break;
          case 12:
            _context5.next = 18;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t1 = _context5["catch"](2);
            _didIteratorError8 = true;
            _iteratorError8 = _context5.t1;
          case 18:
            _context5.prev = 18;
            _context5.prev = 19;
            if (!(_iteratorAbruptCompletion8 && _iterator8.return != null)) {
              _context5.next = 23;
              break;
            }
            _context5.next = 23;
            return _awaitAsyncGenerator(_iterator8.return());
          case 23:
            _context5.prev = 23;
            if (!_didIteratorError8) {
              _context5.next = 26;
              break;
            }
            throw _iteratorError8;
          case 26:
            return _context5.finish(23);
          case 27:
            return _context5.finish(18);
          case 28:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 14, 18, 28], [19,, 23, 27]]);
    }));
    function flatMap() {
      return _flatMap.apply(this, arguments);
    }
    return flatMap;
  }().call(this);
}
function toIntegerOrInfinity(number) {
  // We coerce here to align with the spec
  // https://github.com/tc39/proposal-iterator-helpers/issues/169
  number = Number(number);
  if (NumberIsNaN(number)) {
    return 0;
  }
  if (number < 0) {
    throw new ERR_OUT_OF_RANGE('number', '>= 0', number);
  }
  return number;
}
function drop(number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (options != null) {
    validateObject(options, 'options');
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal');
  }
  number = toIntegerOrInfinity(number);
  return /*#__PURE__*/function () {
    var _drop = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _options$signal5, _iteratorAbruptCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, val, _options$signal6;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted)) {
              _context6.next = 2;
              break;
            }
            throw new AbortError();
          case 2:
            _iteratorAbruptCompletion9 = false;
            _didIteratorError9 = false;
            _context6.prev = 4;
            _iterator9 = _asyncIterator(this);
          case 6:
            _context6.next = 8;
            return _awaitAsyncGenerator(_iterator9.next());
          case 8:
            if (!(_iteratorAbruptCompletion9 = !(_step9 = _context6.sent).done)) {
              _context6.next = 18;
              break;
            }
            val = _step9.value;
            if (!(options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted)) {
              _context6.next = 12;
              break;
            }
            throw new AbortError();
          case 12:
            if (!(number-- <= 0)) {
              _context6.next = 15;
              break;
            }
            _context6.next = 15;
            return val;
          case 15:
            _iteratorAbruptCompletion9 = false;
            _context6.next = 6;
            break;
          case 18:
            _context6.next = 24;
            break;
          case 20:
            _context6.prev = 20;
            _context6.t0 = _context6["catch"](4);
            _didIteratorError9 = true;
            _iteratorError9 = _context6.t0;
          case 24:
            _context6.prev = 24;
            _context6.prev = 25;
            if (!(_iteratorAbruptCompletion9 && _iterator9.return != null)) {
              _context6.next = 29;
              break;
            }
            _context6.next = 29;
            return _awaitAsyncGenerator(_iterator9.return());
          case 29:
            _context6.prev = 29;
            if (!_didIteratorError9) {
              _context6.next = 32;
              break;
            }
            throw _iteratorError9;
          case 32:
            return _context6.finish(29);
          case 33:
            return _context6.finish(24);
          case 34:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this, [[4, 20, 24, 34], [25,, 29, 33]]);
    }));
    function drop() {
      return _drop.apply(this, arguments);
    }
    return drop;
  }().call(this);
}
function take(number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  if (options != null) {
    validateObject(options, 'options');
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal');
  }
  number = toIntegerOrInfinity(number);
  return /*#__PURE__*/function () {
    var _take = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var _options$signal7, _iteratorAbruptCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, val, _options$signal8;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!(options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted)) {
              _context7.next = 2;
              break;
            }
            throw new AbortError();
          case 2:
            _iteratorAbruptCompletion10 = false;
            _didIteratorError10 = false;
            _context7.prev = 4;
            _iterator10 = _asyncIterator(this);
          case 6:
            _context7.next = 8;
            return _awaitAsyncGenerator(_iterator10.next());
          case 8:
            if (!(_iteratorAbruptCompletion10 = !(_step10 = _context7.sent).done)) {
              _context7.next = 20;
              break;
            }
            val = _step10.value;
            if (!(options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted)) {
              _context7.next = 12;
              break;
            }
            throw new AbortError();
          case 12:
            if (!(number-- > 0)) {
              _context7.next = 15;
              break;
            }
            _context7.next = 15;
            return val;
          case 15:
            if (!(number <= 0)) {
              _context7.next = 17;
              break;
            }
            return _context7.abrupt("return");
          case 17:
            _iteratorAbruptCompletion10 = false;
            _context7.next = 6;
            break;
          case 20:
            _context7.next = 26;
            break;
          case 22:
            _context7.prev = 22;
            _context7.t0 = _context7["catch"](4);
            _didIteratorError10 = true;
            _iteratorError10 = _context7.t0;
          case 26:
            _context7.prev = 26;
            _context7.prev = 27;
            if (!(_iteratorAbruptCompletion10 && _iterator10.return != null)) {
              _context7.next = 31;
              break;
            }
            _context7.next = 31;
            return _awaitAsyncGenerator(_iterator10.return());
          case 31:
            _context7.prev = 31;
            if (!_didIteratorError10) {
              _context7.next = 34;
              break;
            }
            throw _iteratorError10;
          case 34:
            return _context7.finish(31);
          case 35:
            return _context7.finish(26);
          case 36:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this, [[4, 22, 26, 36], [27,, 31, 35]]);
    }));
    function take() {
      return _take.apply(this, arguments);
    }
    return take;
  }().call(this);
}
module.exports.streamReturningOperators = {
  asIndexedPairs: deprecate(asIndexedPairs, 'readable.asIndexedPairs will be removed in a future version.'),
  drop: drop,
  filter: filter,
  flatMap: flatMap,
  map: map,
  take: take,
  compose: compose
};
module.exports.promiseReturningOperators = {
  every: every,
  forEach: forEach,
  reduce: reduce,
  toArray: toArray,
  some: some,
  find: find
};